<template>
  <a-modal
    title="转换工作流类型"
    :visible="visible"
    @ok="handleConfirm"
    @cancel="handleCancel"
    :confirmLoading="loading"
  >
    <a-form-model ref="form" :model="formData" :rules="rules">
      <a-form-model-item label="转换到工作流类型" prop="workflowType">
        <a-select
          v-model="formData.workflowType"
          placeholder="请选择要转换的工作流类型"
          style="width: 100%"
        >
          <a-select-option
            v-for="dict in workflowTypeOptions"
            :key="dict.value"
            :value="dict.value"
          >
            {{ dict.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
/**
 * 工作流类型转换弹窗组件
 * 
 * 功能说明：
 * 1. 用于将AI工作流转换为顺序工作流或灵活工作流
 * 2. 通过props接收显示状态和加载状态
 * 3. 通过事件通知父组件确认和取消操作
 * 
 * @author zbtech
 * @date 2025-01-XX
 */
export default {
  name: 'WorkflowConvertModal',
  // 需要使用的字典
  dicts: ['workflow_type'],
  props: {
    // 弹窗显示状态
    visible: {
      type: Boolean,
      default: false
    },
    // 加载状态
    loading: {
      type: Boolean,
      default: false
    },
    // 当前工作流类型
    currentWorkflowType: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      // 表单数据
      formData: {
        workflowType: undefined
      },
      // 表单验证规则
      rules: {
        workflowType: [
          { required: true, message: '请选择工作流类型', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    /**
     * 工作流类型选项（根据当前工作流类型过滤）
     * - 如果是AI工作流（"0"），只显示顺序工作流（"1"）和灵活工作流（"2"）
     * - 如果是顺序工作流（"1"），只显示AI工作流（"0"）和灵活工作流（"2"）
     * - 如果是灵活工作流（"2"），只显示AI工作流（"0"）和顺序工作流（"1"）
     */
    workflowTypeOptions () {
      if (!this.dict || !this.dict.type || !this.dict.type['workflow_type']) {
        return []
      }
      // 如果没有当前工作流类型，返回所有选项（排除当前类型）
      if (!this.currentWorkflowType) {
        return this.dict.type['workflow_type']
      }
      // 过滤掉当前工作流类型，只显示其他可转换的类型
      return this.dict.type['workflow_type'].filter(dict => dict.value !== this.currentWorkflowType)
    }
  },
  watch: {
    // 监听visible变化，重置表单
    visible (newVal) {
      if (newVal) {
        this.resetForm()
      }
    }
  },
  methods: {
    /**
     * 确认转换
     * 验证表单并触发确认事件
     */
    handleConfirm () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('confirm', this.formData.workflowType)
        }
      })
    },
    /**
     * 取消转换
     * 触发取消事件
     */
    handleCancel () {
      this.resetForm()
      this.$emit('cancel')
    },
    /**
     * 重置表单
     */
    resetForm () {
      this.formData.workflowType = undefined
    }
  }
}
</script>

<style scoped>
</style>

